<template>
  <a-layout class="nhf-app">
    <a-alert
      style="
        position: fixed;
        width: 500px;
        min-height: 100px;
        top: 10%;
        left: 50%;
        margin-left: -250px;
        z-index: 100000;
      "
      v-if="ebsIsFalse"
      :message="ebsMessage"
      :type="ebsType"
      show-icon
    >
      <div slot="description">
        <!-- This is an error message about copywriting.1111111111
        ebsList -->
        <div v-if="ebsType !== 'success'">
          <span v-for="(el, index) in ebsList" :key="el.id"
            >{{ el.name }}【{{ el.code }}】{{
              index === ebsList.length - 1 ? "" : "、"
            }}</span
          >
          EBS校验不通过:
        </div>
        <div style="text-align: left">
          <a @click="closeEbsAlert">{{
            ebsType === "success" ? "我知道了" : "返回修改"
          }}</a>
          <a-divider type="vertical" />
          <a v-if="ebsType === 'success'" @click="() => saveFormula({ key: 2 })"
            >生成产品</a
          >
          <a v-else @click="copyMsg">复制信息</a>
        </div>
      </div>
    </a-alert>
    <a-spin
      :spinning="lineLoading || updateLoading"
      :tip="updateLoading ? null : '配方优化中，请稍后'"
    >
      <a-layout-content class="nhf-editor">
        <a-row justify="space-between" type="flex" class="nhf-header">
          <h1 class="nhf-title" @click="goBack">
            <img class="nhf-logo" :src="logo" alt="返回上一页面" />
            <span class="newTextColor">{{ factoryName }}</span>
          </h1>
          <a-space>
            <a-tooltip>
              <template slot="title"> 全屏显示 </template>
              <a @click="full">
                <img v-if="!isFullScreen" :src="fullScreen" alt="全屏显示" />
                <img v-else :src="exitFullScreen" alt="退出全屏" />
              </a>
            </a-tooltip>
            <!-- <a-divider type="vertical" /> -->
            <a-dropdown>
              <a-button
                icon="layout"
                size="small"
                style="font-size: 22px"
              ></a-button>
              <a-menu
                slot="overlay"
                @click="(e) => rightClick({ key: e.key, val: !layout[e.key] })"
              >
                <a-menu-item key="layoutType">切换布局 </a-menu-item>
                <a-menu-item
                  v-if="layout.layoutType"
                  key="showSider"
                  class="vue-simple-context-menu__item"
                  ><span>配方原料列表 <i v-if="layout.showSider" /></span
                ></a-menu-item>
                <a-menu-item
                  v-if="layout.layoutType"
                  key="showRight"
                  class="vue-simple-context-menu__item"
                  ><span>配方营养需要量 <i v-if="layout.showRight" /></span
                ></a-menu-item>
                <a-menu-divider />
                <a-menu-item key="1">配方优化</a-menu-item>
                <a-menu-item key="2">取整优化</a-menu-item>
                <!-- <a-menu-item key="checkEBS" :disabled="detail.formulaSolutionType != 1">EBS校验</a-menu-item> -->
                <a-menu-item key="saveFormula">生成产品 </a-menu-item>
                <a-menu-item
                  key="togglePorductVisible"
                  :disabled="detail.isProduct == 0"
                  >产品对比
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <!-- <a-dropdown style="width: 90px;" v-if="estimateBtn">
              <a-button size="small"  type="default">生长性能预估</a-button>
              <a-menu slot="overlay" @click="changeEstimate">
                <a-menu-item key="1">立即预估</a-menu-item>
                <a-menu-item key="2">历史记录</a-menu-item>
              </a-menu>
            </a-dropdown> -->
            <a-divider type="vertical" />
            <a-button
              size="small"
              type="primary"
              @click="changeLinear({ key: 1 })"
              >配方优化</a-button
            >
            <a-button size="small" @click="changeLinear({ key: 2 })"
              >取整优化</a-button
            >
            <a-divider type="vertical" />
            <!-- <a-dropdown style="width: 90px">
              <a-button size="small">配方优化</a-button>
              <a-menu slot="overlay" @click="changeLinear">
                <a-menu-item key="1">仅优化</a-menu-item>
                <a-menu-item key="2">优化取整</a-menu-item>
              </a-menu>
            </a-dropdown> -->
            <a-button
              :disabled="detail.isProduct == 0"
              size="small"
              @click="togglePorductVisible"
              >产品对比</a-button
            >
            <!-- <a-button
              :disabled="detail.formulaSolutionType != 1"
              size="small"
              @click="checkEBS"
              >EBS校验</a-button> -->
            <a-button size="small" ghost type="primary" @click="viewReport"
              >查看报表</a-button
            >
            <!-- <a-dropdown>
              <a-button size="small" ghost type="primary">查看报表</a-button>
              <a-menu slot="overlay" @click="viewReport">
                <a-menu-item
                  :key="index + 1"
                  v-for="(item, index) in ['配方报表', '生产报表']"
                  >{{ item }}</a-menu-item
                >
              </a-menu>
            </a-dropdown> -->
            <a-dropdown>
              <a-button
                size="small"
                :loading="saveLoading"
                style="width: 84px"
                type="primary"
                >保存</a-button
              >
              <a-menu slot="overlay" @click="saveFormula">
                <a-menu-item
                  v-for="(item, index) in ['保存为原料', '生成产品']"
                  :key="index"
                  >{{ item }}</a-menu-item
                >
              </a-menu>
            </a-dropdown>
          </a-space>
        </a-row>
        <div
          class="nhf-container"
          ref="editorContainer"
          @contextmenu.prevent.stop="handleMenu($event)"
        >
          <a-row
            type="flex"
            align="middle"
            class="nhf-header-main"
            justify="space-between"
          >
            <a-space>
              <h3>{{ detail.formulaName }}</h3>
              <a-icon
                size="small"
                style="font-size: 15px"
                @click="showEdit"
                type="form"
              />
            </a-space>
            <a-row
              type="flex"
              align="middle"
              justify="space-between"
              style="padding: 0 20px"
            >
              <div class="col">
                初始价格（元/吨）
                <h2>
                  {{
                    !detail || !detail.lastPrice
                      ? "0.000"
                      : detail.lastPrice.toFixed(3)
                  }}
                </h2>
              </div>
              <a-divider type="vertical" />
              <div class="col">
                优化价格（元/吨）
                <h2>
                  {{
                    !detail || !detail.price ? "0.000" : detail.price.toFixed(3)
                  }}
                  <span
                    v-if="computedPrice != 0.0"
                    :class="{
                      red: computedPrice > 0,
                      green: computedPrice < 0,
                    }"
                  >
                    <b>/</b>{{ computedPrice }}
                    <a-icon style="font-size: 16px" :type="priceType" />
                  </span>
                </h2>
              </div>
              <a-divider type="vertical" />
              <div class="col">
                产品价格（元/吨）
                <h2>
                  {{
                    !productPrice || !productPrice.price
                      ? "0.000"
                      : productPrice.price.toFixed(3)
                  }}
                  <span
                    v-if="
                      computedProductPrice != 0.0 && productPrice.version > 0
                    "
                    :class="{
                      red: computedProductPrice > 0,
                      green: computedProductPrice < 0,
                    }"
                  >
                    <b>/</b>{{ Number(computedProductPrice).toFixed(3) }}
                    <a-icon style="font-size: 16px" :type="productPriceType" />
                  </span>
                  <span
                    style="
                      font-weight: normal;
                      color: rgba(0, 0, 0, 0.65);
                      font-size: 12px;
                      margin-left: 3px;
                    "
                    v-if="productPrice && productPrice.version > 0"
                    >({{
                      productPrice.createTime
                        ? moment(productPrice.createTime).format("YYYY-MM-DD")
                        : ""
                    }}，V{{ productPrice.version }})</span
                  >
                </h2>
              </div>
            </a-row>
          </a-row>
          <!-- layout 1 -->
          <div
            class="nhf-layout"
            ref="box"
            style="overflow: hidden"
            v-if="layout.layoutType"
          >
            <div class="tableleft" :style="leftStyle" v-show="layout.showSider">
              <raw-editor
                @refreshNutrition="refreshNutrition"
                @refresh="refreshUpdate"
                @prcieChange="prcieChange"
                ref="rawBlock"
                @add="toggleRawPanel"
                @countPrice="countPrice"
              >
                <a-space class="icon-bar">
                  <!-- <a-button size="small" ghost @click="toggleHidden('rawRows')" type='primary' :disabled="!rawRows.length">原料养分控制</a-button> -->
                  <!-- <a-button :disabled="!rawRows.length > 0 || !(rawRows.length > 0 && rawRows[0].percentage > 0)" size="small" @click="toggleHasAnalyse" type='primary'>梯度分析</a-button> -->
                  <a-tooltip>
                    <template slot="title">原料过滤</template>
                    <a-dropdown>
                      <!-- <a-button type="link" icon="control" /> -->
                      <a-button type="link">
                        <img :src="filterMaterial" alt="原料过滤" />
                      </a-button>
                      <a-menu slot="overlay" class="menu">
                        <!-- <a-radio-group
                          :defaultValue="rawTypeSelect"
                          :options="rawTypesRadio"
                          @change="(e) => setRawTypeSelect(e.target.value)"
                        /> -->
                        <a-menu-item>
                          <span
                            :style="{
                              color: rawTypeSelect === 0 ? '#1890ff' : '',
                            }"
                            @click="() => setRawTypeSelect(0)"
                            >所有原料</span
                          >
                        </a-menu-item>
                        <a-menu-item>
                          <span
                            :style="{
                              color: rawTypeSelect === 1 ? '#1890ff' : '',
                            }"
                            @click="() => setRawTypeSelect(1)"
                            >组分原料</span
                          >
                        </a-menu-item>
                        <a-menu-item>
                          <span
                            :style="{
                              color: rawTypeSelect === 2 ? '#1890ff' : '',
                            }"
                            @click="() => setRawTypeSelect(2)"
                            >拒绝原料</span
                          >
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                  </a-tooltip>
                  <!-- <a-tooltip>
                    <template slot="title">梯度分析</template>
                    <a-button type="link" :disabled="rawRows.length != 1" @click="toggleHasAnalyse">
                      <img :src="gradientAnalysis" alt="梯度分析" />
                    </a-button>
                  </a-tooltip> -->
                  <table-filter-col type="raw" />
                </a-space>
              </raw-editor>
            </div>
            <div
              v-show="layout.showSider && layout.showRight"
              class="resize"
              title="左右拖动调整宽度"
            />
            <div
              v-show="layout.showRight"
              class="tableright"
              :style="rightStyle"
            >
              <nutrition-editor
                @refresh="refreshUpdate"
                ref="nutritionBlock"
                @res="getDetail"
              />
            </div>
          </div>
          <!-- layout 2 -->
          <a-tabs
            @change="tabChange"
            :activeKey="tabSelect"
            :animated="false"
            v-else
          >
            <a-tab-pane key="1" tab="配方原料" :forceRender="true">
              <raw-editor
                @refreshNutrition="refreshNutrition"
                @refresh="refreshUpdate"
                @prcieChange="prcieChange"
                ref="rawBlock"
                @add="toggleRawPanel"
                @countPrice="countPrice"
              />
            </a-tab-pane>
            <a-tab-pane key="2" tab="配方营养需要量" :forceRender="true">
              <nutrition-editor
                @refresh="refreshUpdate"
                ref="nutritionBlock"
                @res="getDetail"
              />
            </a-tab-pane>
            <a-space slot="tabBarExtraContent" class="icon-bar">
              <template v-if="tabSelect == 1">
                <a-tooltip>
                  <template slot="title">导入产品库</template>
                  <a-button type="link" @click="showImportProject">
                    <img width="20" :src="importProduct" alt="导入产品库" />
                  </a-button>
                </a-tooltip>
                <a-tooltip>
                  <template slot="title">添加原料</template>
                  <!-- <a-button
                    type="link"
                    icon="file-add"
                    @click="addRawActions"
                  /> -->
                  <a-button type="link" @click="addRawActions">
                    <img :src="addImg" alt="添加原料" />
                  </a-button>
                </a-tooltip>
                <a-tooltip>
                  <template slot="title">移出原料</template>
                  <a-badge :count="rawRows.length">
                    <!-- <a-button
                      icon="delete"
                      type="link"
                      :disabled="rawRows.length == 0"
                      @click="removeRaw"
                    /> -->
                    <a-button
                      type="link"
                      :disabled="rawRows.length === 0"
                      @click="removeRaw"
                    >
                      <img :src="deleteImg" alt="移出原料" />
                    </a-button>
                  </a-badge>
                </a-tooltip>
              </template>
              <!-- <a-button v-if="tabSelect ==1" size="small" @click="toggleHidden('rawRows')" :disabled="!rawRows.length">原料养分控制</a-button>
              <a-button v-if="tabSelect ==2" size="small" @click="toggleHidden('nutRows')" :disabled="!nutRows.length">营养养分控制</a-button> -->
              <a-tooltip v-if="tabSelect == 2">
                <template slot="title">养分选择表</template>
                <a-button type="link" @click="toggleVisible('nutChoose')">
                  <img :src="nutrientSelection" alt="养分选择表" />
                </a-button>
              </a-tooltip>
              <!-- <a-tooltip v-if="tabSelect == 1">
                <template slot="title">梯度分析</template>
                <a-button type="link" :disabled="rawRows.length != 1" @click="toggleHasAnalyse">
                  <img :src="gradientAnalysis" alt="梯度分析" />
                </a-button>
              </a-tooltip> -->
              <a-tooltip v-if="tabSelect == 1">
                <template slot="title">原料过滤</template>
                <a-dropdown>
                  <!-- <a-button type="link" icon="control" /> -->
                  <img :src="filterMaterial" alt="原料过滤" />
                  <a-menu slot="overlay" class="menu">
                    <!-- <a-radio-group
                      :defaultValue="rawTypeSelect"
                      :options="rawTypesRadio"
                      @change="(e) => setRawTypeSelect(e.target.value)"
                    /> -->
                    <a-menu-item>
                      <span
                        :style="{ color: rawTypeSelect === 0 ? '#1890ff' : '' }"
                        @click="() => setRawTypeSelect(0)"
                        >所有原料</span
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <span
                        :style="{ color: rawTypeSelect === 1 ? '#1890ff' : '' }"
                        @click="() => setRawTypeSelect(1)"
                        >组分原料</span
                      >
                    </a-menu-item>
                    <a-menu-item>
                      <span
                        :style="{ color: rawTypeSelect === 2 ? '#1890ff' : '' }"
                        @click="() => setRawTypeSelect(2)"
                        >拒绝原料</span
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-tooltip>
              <table-filter-col type="raw" v-if="tabSelect == 1" />
              <nut-filter-value @change="filterNut" v-if="tabSelect == 2" />
              <table-filter-col type="nut" v-if="tabSelect == 2" />
            </a-space>
          </a-tabs>
        </div>
      </a-layout-content>
      <!-- <product-modal :hidden="productVisible" @cancel="togglePorductVisible" /> -->
      <product-comparison
        :hidden="productVisible"
        @cancel="togglePorductVisible"
        :productPrice="productPrice"
      />
      <compound-create-modal @close="closeEdit" :hidden="editorVisible" />
      <analyse-modal
        :rawitem="rawRows"
        :hidden="analyseVisible"
        @close="toggleAnalyse"
      />
      <vue-simple-context-menu
        :elementId="'layoutMenu'"
        :options="layoutOption"
        ref="contextMenuContainer"
        @option-clicked="menuChecked"
      />
      <raw-save-modal @ok="refreshPage" />
    </a-spin>
    <estimated-confirm-modal />
    <check-EBS
      :visible="ebsPushVisible"
      @close="closeCheckEBS"
      @checkEbsRes="checkEbsRes"
    />
  </a-layout>
</template>

<script>
import { nhfMixins } from "../untils";

import logo from "../../../assets/images/logo_nhf.svg";
import fullScreen from '@/assets/images/icon/fullScreen.png'
import exitFullScreen from '@/assets/images/icon/exitFullScreen.png'
import filterMaterial from '@/assets/images/icon/filterMaterial.png'
import gradientAnalysis from '@/assets/images/icon/gradientAnalysis.png'
import nutrientSelection from '@/assets/images/icon/nutrientSelection.png'
import addImg from '@/assets/images/icon/add.png'
import deleteImg from '@/assets/images/icon/delete.png'
import importProduct from '@/assets/images/icon/importProduct.png'


import NutritionEditor from "./editor/NutritionEditor.vue";
import RawEditor from "./editor/RawEditor.vue";
import AnalyseModal from "./modal/AnalyseModal.vue";
import CompoundCreateModal from "./modal/CompoundCreateModal.vue";
import VueSimpleContextMenu from "vue-simple-context-menu";
import TableFilterCol from "./editor/TableFilterCol.vue";
import NutFilterValue from "./editor/NutFilterValue.vue";
import rawColumns from "./editor/rawColumns";
import nutColumns from "./editor/nutColumns";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import RawSaveModal from "./modal/RawSaveModal.vue";
import { getRequest } from "@/components/Common/Utils/Utils";
import EstimatedConfirmModal from './modal/EstimatedConfirmModal.vue'
import ProductComparison from './modal/ProductComparison.vue'
import CheckEBS from './modal/CheckEBS.vue'
import moment from 'moment'
export default {
  components: {
    NutritionEditor,
    RawEditor,
    // ProductModal,
    CompoundCreateModal,
    AnalyseModal,
    VueSimpleContextMenu,
    TableFilterCol,
    RawSaveModal,
    NutFilterValue,
    EstimatedConfirmModal,
    ProductComparison,
    CheckEBS,
  },
  mixins: [nhfMixins],
  data() {
    return {
      ebsPushVisible: false,
      ebsList: [],
      ebsIsFalse: false,
      ebsMessage: '请注意！',
      ebsType: 'warning',
      rawColumns, nutColumns,
      logo, fullScreen, exitFullScreen, filterMaterial, gradientAnalysis, nutrientSelection, addImg, deleteImg, importProduct, // icon
      editorContainerHeight: 400,
      resultVisible: false,
      saveLoading: false,
      productVisible: false,
      editorVisible: false,
      lineLoading: false,
      saveVisible: false,
      top: 0,
      goodLoading: false,
      rawVisible: false,
      nutritenVisible: false,
      nutritenDetailVisible: false,
      needVisible: false,
      needType: null,
      productPrice: null,
      updateLoading: false,
      refreshNoticeCompound: null,
      tabSelect: "1",
      analyseVisible: false,
      form: {},
      leftHalfWidth: null,
      rightHalfWidth: null,
      factoryName: window.localStorage.getItem("factoryName"), //工厂名称
      id: getRequest("id"), //保存当前路由id
      estimateBtn: false,// 立即预估按钮显示隐藏
      isFirst: true,
    };
  },
  mounted() {
    this.contrastTargetAddDiff()
    // if(!this.layout.layoutType) {
    //   this.initSize();
    //   this.getContainerHeight();
    //   this.init()
    // }
    window.document.addEventListener("keydown", this.listenKeyCode);
  },
  beforeDestroy() {
    clearInterval(this.refreshNoticeCompound);
    this.refreshNoticeCompound = null;
  },
  watch: {
    "layout.layoutType"(val) {
      this.initSize();
      this.getContainerHeight();
      this.init()
      if (this.isFirst) {
        this.handleLayout({ key: 'layoutType', val })
        this.isFirst = false
      }
    },
  },
  computed: {
    leftStyle() {
      const { leftHalfWidth } = this;
      const { showRight, showSider, layoutType } = this.layout;
      let width = showRight && leftHalfWidth ? `${leftHalfWidth}px` : "";
      if (!showRight && !showSider) width = "100%";
      return {
        width,
        float: layoutType && showSider && !showRight ? "none" : "left",
      };
    },
    rightStyle() {
      const { rightHalfWidth } = this;
      const { showRight, showSider } = this.layout;
      let width = '';
      if (showSider && showRight && rightHalfWidth) {
        width = `${rightHalfWidth}px`
      }
      if (!showSider && showRight && rightHalfWidth) {
        width = '100%'
      }
      if (!showRight) width = ''
      return {
        width,
      };
    },
    layoutOption() {
      const {
        showSider,
        showRight, layoutType } = this.layout;
      const item = [
        {
          type: "divider",
        },
        {
          name: `<b>配方原料列表</b> ${showSider ? "<i />" : ""}`,
          commit: "showSider",
        },
        {
          name: `<b>配方营养需要量</b> ${showRight ? "<i />" : ""}`,
          commit: "showRight",
        },
      ];
      const base = [
        {
          name: `切换布局`,
          commit: "layoutType",
        },
      ];
      const other = [
        {
          type: "divider",
        },
        {
          name: `导入产品库`,
          commit: 'showImportProject'
        },
        {
          name: `添加原料`,
          commit: 'addRawActions'
        },
        {
          name: `移除原料`,
          commit: this.rawRows.length !== 0 ? 'removeRaw': '',
          class: this.rawRows.length === 0 ? 'disabledMenu' : ''
        },
        {
          type: "divider",
        },
        {
          name: `配方优化`,
          commit: "1",
        },
        {
          name: `取整优化`,
          commit: "2",
        },
        {
          type: "divider",
        },
        // {
        //   name: `EBS校验`,
        //   commit: this.detail.formulaSolutionType == 1 ? "checkEBS" : '',
        //   class: this.detail.formulaSolutionType == 1 ? "" : 'disabledMenu'
        // },
        {
          name: `产品对比`,
          commit: this.detail.isProduct != 0 ? "togglePorductVisible" : '',
          class: this.detail.isProduct === 0 ? "disabledMenu" : ''
        },
        {
          name: `生成产品`,
          commit: "saveFormula",
        },
      ]
      return layoutType ? [...base, ...item, ...other] : [...base, ...other];
    },
    computedPrice() {
      const { price, lastPrice } = this.detail || {};
      return lastPrice != null && price != null
        ? (price - lastPrice).toFixed(3)
        : "";
    },
    priceType() {
      return this.computedPrice > 0 ? "arrow-up" : "arrow-down";
    },
    computedProductPrice() {
      let { price } = this.productPrice || {};
      let { price: detailsPrice } = this.detail || {};
      return price != null && detailsPrice != null
        ? (-price + detailsPrice).toFixed(3)
        : "";
    },
    productPriceType() {
      return this.computedProductPrice > 0 ? "arrow-up" : "arrow-down";
    },
  },

  methods: {
    moment,
    copyMsg() {
      let random = '';
      // {{el.name}}【{{el.code}}】{{index === ebsList.length - 1 ? '' : '、'}}
      this.ebsList.forEach((el, index) => {
        random += `${el.name}【${el.code}】${this.ebsList.length - 1 === index ? '' : ';'}`
      })
      random += 'EBS校验不通过'
      const input = window.document.createElement('textarea');
      window.document.body.appendChild(input);
      input.innerHTML = random
      // input.setAttribute('value',random);
      // input.select();
      input.setAttribute('code', 1);
      input.select();
      window.document.execCommand("Copy");
      this.$message.success('复制成功')
      this.closeEbsAlert()
    },
    closeCheckEBS() {
      // if(type) this.init()
      this.ebsPushVisible = false
    },
    checkEBS() {
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      }
      this.$http.get('/iot-factory/factorysublink/subFactoryList', { params }).then(res => {
        let { data, success } = res || {}
        if (success) {
          this.$confirm({
            title: 'EBS校验',
            content: '校验配方组分原料在工厂库存组织中是否存在？',
            cancelText: '取消',
            okText: '继续',
            onOk: async () => {
              if (data.length > 0) {
                this.ebsPushVisible = true
              } else {
                let params = {
                  formulaId: this.formulaId,
                  ebsPushFactoryId: window.localStorage.getItem('factoryId')
                }
                this.$http.get('/nhf-app/formulaNhf/batchFormulaRawEbsCheck', { params }).then(res => {
                  let { data: msgData } = res || {}
                  this.checkEbsRes(msgData)
                })
              }
            },
          });
        }
      })

    },

    checkEbsRes(data) {
      if (data.length === 0) {
        this.ebsIsFalse = true
        this.ebsMessage = '校验通过！'
        this.ebsType = 'success'
        this.$message.success('校验成功')
      } else {
        this.ebsList = data || []
        this.ebsIsFalse = true
        this.ebsMessage = '请注意！'
        this.ebsType = 'warning'
      }
    },
    closeEbsAlert() {
      this.ebsList = []
      this.ebsMessage = ''
      this.ebsType = ''
      this.ebsIsFalse = false
    },
    listenKeyCode(e) {
      if (e.altKey && e.keyCode === 79) this.changeLinear({ key: 1 }) // 配方优化: 组合键 alt + o
      if (e.altKey && e.keyCode === 76) this.changeLinear({ key: 2 }) // 取整优化: 组合键 alt + l
    },
    refreshNutrition() {
      this.$refs.nutritionBlock && this.$refs.nutritionBlock.getList()
    },
    async updateModal() {
      let data = {
        formulaId: this.id
      }
      await this.fetchGet({
        actions: this.contrastTargetModelAddDiff,
        data,
      });
      this.initMounted()
    },
    contrastTargetAddDiff() {
      let params = {
        formulaId: this.id
      }
      this.$http.get('/nhf-app/formulaManage/contrastTargetAddDiff', { params }).then(res => {
        let { success } = res || {}
        if (success) {
          this.initMounted()
        }
      })
    },
    initMounted() {
      this.$nextTick(() => {
        this.getContainerHeight();
        this.initSize();
        this.init()
      });
      this.setState({
        visible: {
          raw: false,
          nut: false,
          nut2: false,
          result: false,
          result2: false,
          nutChoose: false,
          raw2: false,
          saveRaw: false,
          estimated: false,
          nhfEstimateData: {}
        }
      })
      this.getFactoryDetails();
      let layoutType = window.localStorage.getItem('layoutType')
      let showSider = window.localStorage.getItem('showSider')
      let showRight = window.localStorage.getItem('showRight')
      let rawTypeSelect = window.localStorage.getItem('rawTypeSelect')
      this.mountedHandleLayout({ key: 'layoutType', val: layoutType === 'layoutType' ? true : false })
      if (showSider) {
        this.mountedHandleLayout({ key: 'showSider', val: showSider !== 'setFalse' })
      } else {
        this.mountedHandleLayout({ key: 'showSider', val: true })
      }
      if (showRight) {
        this.mountedHandleLayout({ key: 'showRight', val: showRight !== 'setFalse' })
      } else {
        this.mountedHandleLayout({ key: 'showRight', val: true })
      }
      if (rawTypeSelect) this.setRawTypeSelect(Number(rawTypeSelect))
      // 获取按钮权限
      this.getBtn()
      this.getNutrition()
    },
    countPrice(val) {
      let mix = Math.abs((this.detail.price || 0) - (val || 0)) > 0.01
      if (mix) {
        this.detail.price = Number(val) || 0
        this.updatePrice(this.detail)
      }
    },

    async updatePrice(data) {
      await this.fetchPost({
        actions: this.updateCustomFormulaPrice,
        // loading: "updateLoading",
        data,
      });
      this.getDetail()
    },
    getNutrition() {
      this.$get('/nhf-core-data/animalnutrition/animalNutritionUserPage', { size: 1000, current: 1 }).then(res => {
        let { success, data } = res || {}
        if (success) {
          let { records } = data || {}
          this.setState({ nutritionList: records })
        }
      })
    },
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId')
      if (!factoryId) return
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          data && data.forEach(el => {
            if (el.path === '/nhf/compound-feed') {
              el.children && el.children.forEach(item => {
                if (item.code === 'third-estimate') this.estimateBtn = true
              })
            }
          })
        }
      });
    },
    setRawTypeSelect(rawTypeSelect) {
      this.setState({ rawTypeSelect })
      window.localStorage.setItem('rawTypeSelect', rawTypeSelect)
    },
    getFactoryDetails() {
      let id = window.localStorage.getItem('factoryId')
      if (!id) {
        this.$get('/iot-factory/factory/detail', { id }).then(res => {
          let { success, data } = res || {}
          if (success) {
            let { overseasFlag } = data || {}
            this.overseasFlag = overseasFlag
            if (overseasFlag != window.localStorage.getItem('overseasFlag')) {
              window.localStorage.setItem('overseasFlag', overseasFlag)
            }

            // 存一个工厂的详细信息
            window.localStorage.setItem('factoryDetail', JSON.stringify(data))
          }
        })
      }
    },
    initSize() {
      this.$nextTick(() => {
        const width = this.$refs["editorContainer"]
          ? this.$refs["editorContainer"].offsetWidth
          : null;
        if (width) {
          this.leftHalfWidth = (width - 6) * 0.6;
          this.rightHalfWidth = (width - 6) * 0.4;
        }
      });
    },
    filterNut(val) {
      this.$refs["nutritionBlock"].filterList(val);
    },
    async init() {
      const { id } = this.$route.query;
      this.formulaId = id;
      this.refreshPage()
      window.onresize = () => {
        this.getContainerHeight();
        this.initSize();
      };
      this.dragControllerDiv();
    },
    removeRaw() {
      this.$refs["rawBlock"].removeRaw();
    },
    showImportProject() {
      this.$refs["rawBlock"].showImportProject();
    },
    addRawActions() {
      this.$refs["rawBlock"].toggleRawVisible();
    },
    goBack() {
      this.$router.push("/nhf/customized-list?name=定制料");
    },
    mountedHandleLayout(e) {
      this.toggleLayout({ feild: e.key, val: e.val });
    },
    rightClick(e) {
      let { key } = e || {}
      if (key === '1' || key === '2') {
        this.changeLinear({ key })
      } else if (key === 'saveFormula') {
        this.saveFormula({ key: 1 })
      } else if (key === 'showSider' || key === 'showRight' || key === 'layoutType') {
        this.handleLayout(e)
      } else {
        this[key]()
      }
    },
    handleLayout(e) {
      let { key, val } = e || {}
      let feildObj = {
        showRight: 'showSider',
        showSider: 'showRight'
      }
      if (val) {
        this.toggleLayout({ feild: key, val });
      } else {
        this.toggleLayout({ feild: key, val: false });
        this.toggleLayout({ feild: feildObj[key], val: true });
      }

      setTimeout(() => {
        if (e.val && e.key === 'layoutType') {
          this.init()
        }
      }, 0);
    },
    handleMenu(event) {
      this.$refs.contextMenuContainer.showMenu(event);
    },
    menuChecked({ option }) {
      const { commit } = option;
      if (['layoutType', 'showSider', 'showRight'].includes(commit)) {
        let val = !this.layout[commit]
        setTimeout(() => {
          if (val && commit === 'layoutType') {
            this.init()
          }
        }, 0);
        let feildObj = {
          showRight: 'showSider',
          showSider: 'showRight'
        }
        if (val) {
          this.toggleLayout({ feild: commit, val });
        } else {
          this.toggleLayout({ feild: commit, val: false });
          this.toggleLayout({ feild: feildObj[commit], val: true });
        }
      } else {
        if (commit) {
          this.rightClick({ key: commit })
        }
      }
    },

    toggleHasAnalyse() {
      this.rawRows.length > 1
        ? this.$message.warn("只能选中一个原料")
        : this.rawRows.length > 1 ? this.$message.warn("请选择一个原料") : this.toggleAnalyse();
    },

    // 梯度分析
    toggleAnalyse() {
      this.analyseVisible = !this.analyseVisible;
    },

    getContainerHeight() {
      const boxHeight = this.$refs["editorContainer"]
        ? this.$refs["editorContainer"].offsetHeight
        : 900;
      const height = boxHeight - (this.layout.layoutType ? 140 : 160);
      this.editorContainerHeight = height;
      this.setState({ height });
    },

    // 配方页通知已读
    async refreshUpdate(callback) {
      // 配方最优解
      let updateData = {
        "formulaSolutionType": "0",
        "id": getRequest('id')
      }
      this.fetchPost({
        actions: this.updateCustomFormulaSolutionType,
        data: updateData,
        showMessage: false
      })
      this.detail.formulaSolutionType = '0'
      callback && callback();
    },

    async refreshPage() {
      clearInterval(this.refreshNoticeCompound);
      this.refreshNoticeCompound = null;
      await this.getDetail();
      // await this.getPrice();
      this.$refs["nutritionBlock"] && this.$refs["nutritionBlock"].getList();
      this.$refs["rawBlock"] && this.$refs["rawBlock"].getList();
    },

    //预估跳转
    changeEstimate({ key: optimizationType }) {
      if (optimizationType == 1) {
        // this.$router.push('/sat/estimated-record/add?id='+this.id)
        // let route =this.$router.resolve({path:'/sat/estimated-record/add?id='+this.id})
        // window.open(route.href,"_blank")
        this.toggleVisible('estimated')
      } else {
        // this.$router.push('/sat/estimated-record?id='+this.id)
        let route = this.$router.resolve({ path: '/sat/estimated-record?id=' + this.id })
        window.open(route.href, "_blank")
      }
    },

    async changeLinear({ key: optimizationType }) {
      if (this.$refs["rawBlock"].cacheData.length == 0) {
        this.$message.warning("请添加原料后优化");
        return;
      }
      let countMin = 0
      let list = this.$refs["rawBlock"].cacheData
      let list2 = this.$refs.nutritionBlock.cacheData
      list && list.forEach(el => {
        if (el.isExtraProRaw !== '1' && el.isRawDelete !== '1') {
          countMin += Number(el.minValue || 0)
        }
      })
      let warnFlag = false
      let gt = '>'
      let contentStr = ''
      let contentStr2 = ''
      let str = null
      let str2 = null
      str = list && list.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true
          contentStr += `配方原料:【${el.rawName}】的最小值 ${gt} 最大值；\r\n`
          return <p>配方原料:【{el.rawName}】的最小值 {gt} 最大值</p>
        }
      })
      str2 = list2 && list2.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true
          contentStr2 += `配方营养需要量:【${el.nutritionName}】的最小值 ${gt} 最大值；\r\n`
          return <p>配方营养需要量:【{el.nutritionName}】的最小值 {gt} 最大值</p>
        }
      })
      // if(!this.layout.layoutType){
      //   if(this.tabSelect == 1) {
      //     str2 = null
      //     contentStr2 = ''
      //   }else{
      //     str = null
      //     contentStr = ''
      //   }
      // }
      if (warnFlag) {
        this.$confirm({
          icon: () => <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#ffa600" />,
          title: '请注意',
          content: <div>{str}{str2}</div>,
          cancelText: '返回修改',
          okText: '复制信息',
          width: 500,
          // duration: 0,
          onOk: () => {
            let random = contentStr + contentStr2;
            const input = window.document.createElement('textarea');
            window.document.body.appendChild(input);
            input.innerHTML = random
            // input.setAttribute('value',random);
            // input.select();
            input.setAttribute('code', 1);
            input.select();
            window.document.execCommand("Copy");

            var list = document.getElementsByTagName('textarea');
            var inputList = Array.prototype.slice.call(list);
            inputList.forEach((item) => {
              if (item.getAttribute('code')) document.body.removeChild(item);
            })
            this.$message.success('复制成功')
          },
          class: 'test',
        });
        return
      }
      // let f = '<='
      // <p>最小值总和应 {f} <span style="color: #ff4d4f;">{Number(100).toFixed(3)}</span></p>
      // <span style="color: #ff4d4f;">原料最小值总和：{countMin.toFixed(3)}</span>
      countMin = Number(countMin.toFixed(3))
      if (countMin > 100) {
        this.$warning({
          title: '配方无解',
          content: <div>
            <p>原料最小值总和为：<span style="color: #ff4d4f;">{countMin.toFixed(3)}</span> ，请调整原料约束!</p>
          </div>,
        });
        return
      }
      const data = {
        formulaId: this.formulaId,
        optimizationType,
      };
      const resp = await this.fetchGet({
        actions: this.customLinearOptimizationByOpt,
        data,
        showError: false,
        loading: "lineLoading",
      });
      let res = resp.data || {}
      if (res && res.success) {
        this.refreshPage();
        this.$message.success(res ? res.msg : '');
      } else {
        this.$warning({
          okText: '确定',
          title: "优化失败",
          content: res ? res.msg : '配方无解，请检查配方原料或营养需要量约束条件！',
          // content: "配方无解，请检查配方原料或营养需要量约束条件！",
        });
      }
    },

    async viewReport() {
      // let routeUrl = this.$router.resolve({
      //   path: `/nhf-compound-report?id=${this.formulaId}&formulaReportType=${formulaReportType}`,
      // });
      // window.open(routeUrl.href, "_blank");
      // let url = [
      //   "/nhf-app/formulahis/exportFormulaExcelReport",
      //   "/nhf-app/formulahis/exportFormulaProExcelReport",
      // ];
      // let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      // this.$fileDownload(url[key - 1], { formulaId: this.formulaId,aliasFlag }).catch(
      //   (e) => {
      //     e.message && this.$message.error(e.message);
      //   }
      // );
      // this.$fileDownload('/nhf-app/formulahis/exportFormulaExcelReport',{formulaId: this.formulaId}).catch(e => {
      //   this.$message.error(e.message)
      // })
      let res = await this.fetchPost({
        actions: this.generateCustomFormulaRecipe,
        loading: "updateLoading",
        showMessage: false,
        data: {
          formulaId: this.formulaId,
        },
      });
      let { msg, url, code } = res || {}
      if (code == 200) {
        window.open(url, '_blank')
      } else {
        this.$message.warning(msg)
      }

    },

    prcieChange(val) {
      if (val) this.detail.price = val;
    },

    closeEdit(type) {
      if (type) this.init()
      this.editorVisible = false
    },
    showEdit() {
      this.editorVisible = true
    },

    togglePorductVisible() {
      this.productVisible = !this.productVisible;
    },

    tabChange(val) {
      this.tabSelect = val;
      this.setState({ rawRows: [], nutRows: [] });
      if (val == 1) this.$refs["rawBlock"] && this.$refs["rawBlock"].getList();
      if (val == 2) this.$refs["nutritionBlock"] && this.$refs["nutritionBlock"].getList();
    },

    async linearGood() {
      await this.fetchGet({
        actions: this.linearOptimization,
        loading: "goodLoading",
        data: {
          formulaId: this.formulaId,
        },
      });
      this.refreshPage();
    },

    toggleNeedVisible() {
      if (this.selectNutData.length > 1) {
        this.$message.info(`多个营养指标养分不能同时查看··`);
      } else {
        this.needVisible = !this.needVisible;
      }
    },

    toggleNutritenVisible() {
      if (this.rawSelect.length > 1) {
        this.$message.info(`多个原料不能同时查看`);
      } else {
        this.nutritenVisible = !this.nutritenVisible;
      }
    },

    toggleRawPanel() {
      this.rawVisible = !this.rawVisible;
    },

    toggleHidden(name) {
      if (this[name].length > 1) {
        this.$message.info(
          `多个${name == "rawRows" ? "原料" : "营养指标养分"}不能同时查看`
        );
        return;
      }
      const visible = name == "rawRows" ? "raw" : "nut";
      this.toggleVisible(visible);
    },

    async getDetail() {
      const res = await this.fetchGet({
        actions: this.customformulaDetail,
        // name:'detail',
        data: {
          id: this.formulaId,
        },
      });
      res && res.data && this.setState({
        detail: res.data,
      });
      this.getPrice()
    },
    async getPrice() {
      const productPrice = await this.fetchPost({
        actions: this.customGetProductPrice,
        showMessage: false,
        data: {
          formulaId: this.formulaId,
        },
      });
      this.productPrice = productPrice;
    },

    dragControllerDiv() {
      const resize = document.getElementsByClassName("resize");
      const left = document.getElementsByClassName("tableleft");
      const mid = document.getElementsByClassName("tableright");
      const box = document.getElementsByClassName("nhf-layout");
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = (e) => {
          resize[i].style.background = "#e8e8e8";
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          document.onmousemove = (e) => {
            var endX = e.clientX;
            var moveLenght = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
            if (moveLenght < 400) moveLenght = 400; // 左边区域的最小宽度为32px
            if (moveLenght > maxT - 400) moveLenght = maxT - 400; //右边区域最小宽度为150px
            resize[i].style.left = moveLenght; // 设置左侧区域的宽度
            for (let j = 0; j < left.length; j++) {
              // left[j].style.width = moveLenght + "px";
              // mid[j].style.width = box[i].clientWidth - moveLenght - 5 + "px";
              let leftWidth = parseInt((moveLenght / box[i].clientWidth) * 100);
              let rightWidth = parseInt(
                ((box[i].clientWidth - moveLenght - 5) / box[i].clientWidth) *
                100
              );
              left[j].style.width = leftWidth + "%";
              mid[j].style.width = rightWidth + "%";
            }
          };
          document.onmouseup = () => {
            resize[i].style.background = "#fff";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },

    checkLiner() {
      return this.$refs["rawBlock"].list.records.some(
        (i) => i.percentage === "" || i.percentage === null
      );
    },

    saveCompound() {
      if (this.checkLiner()) {
        this.$message.warning("配方还未优化,无法更新配方版本");
        return;
      }
      this.$confirm({
        title: "保存提醒",
        content: "配方没有进行优化，或者优化后无解的情况，无法更新配方版本。",
        cancelText: "取消",
        okText: "保存并更新版本",
        onOk: () => this.formulaProduct(),
        // onCancel: () => this.saveFormulaProVersion(),
      });
    },

    async saveProductCompound() {
      if (!this.checkRaw()) {
        this.$message.warning("配方中没有原料，无法生成产品！");
        return;
      }
      if (!this.checkMateril()) {
        this.$message.warning("配方中不包含客户原料，无法生成产品");
        return;
      }
      // if (this.checkLiner()) {
      //   this.$message.warning("配方还未优化,无法生成产品！");
      //   return;
      // }
      if (this.detail.formulaSolutionType !== '1') {
        this.$message.warning("配方还未优化,无法生成产品！");
        return
      }
      await this.saveProduce();
    },
    checkRaw() {
      return (
        this.$refs["rawBlock"].list.records &&
        this.$refs["rawBlock"].list.records.length > 0
      );
    },
    checkMateril() {
      let lst = this.$refs["rawBlock"].list.records || []
      let marterial = lst.filter(el => el.productType === 1 && el.isRawDelete != 1) || []
      return marterial.length > 0 ? true : false
    },

    async saveFormulaProVersion() {
      await this.fetchPost({
        actions: this.saveProVersion,
        loading: "saveLoading",
        data: {
          formulaId: this.formulaId,
        },
      });
    },

    async formulaProduct() {
      await this.fetchPost({
        actions: this.saveFormulaProduct,
        loading: "saveLoading",
        data: {
          formulaId: this.formulaId,
        },
      });
    },

    async saveProduce() {
      const hide = this.$message.loading("产品生成中，请稍后...", 0);
      await this.fetchPost({
        actions: this.saveCustomPro,
        loading: "saveLoading",
        data: { formulaId: this.formulaId },
      });
      // this.getDetail()
      this.refreshPage()
      setTimeout(hide, 0);
    },
    saveRawFormula() {
      if (this.$refs["rawBlock"].list.records.length == 0) {
        this.$message.warning("请添加原料");
        return;
      }
      if (this.checkLiner()) {
        this.$message.warning("配方还未优化,无法保存为原料");
        return;
      }
      this.toggleVisible("saveRaw");
    },
    async saveFormula({ key }) {
      this.closeEbsAlert()
      const actions = [
        this.saveRawFormula,
        this.saveProductCompound,
      ];
      let flag = true
      if (key == 2 || key == 3) {
        if (this.detail.formulaSolutionType == 0) {
          flag = false
          this.$message.warning('请先进行配方优化')
        }
      }
      if (!flag) return
      // await actions[key]().then(() => {
      //   this.refreshPage();
      // });
      await actions[key]()
    },
  },
};
</script>
<style lang="scss" scoped>
.menu {
  padding: 5px 15px;
  ::v-deep .ant-radio-wrapper {
    display: block;
    margin: 10px 0;
  }
}
.icon-bar ::v-deep .anticon {
  font-size: 16px !important;
}
::v-deep .ant-tabs-bar {
  margin: 0 10px;
}
//   ::v-deep .ant-table-body::-webkit-scrollbar, ::v-deep.list-container::-webkit-scrollbar {
//     width : 4px;
//     height: 4px;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-thumb,::v-deep.list-container::-webkit-scrollbar-thumb {
//     border-radius: 0;
//     background   : #888;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-track,::v-deep.list-container::-webkit-scrollbar-track {
//     border-radius: 0;
//     background : #e8e8e8;
//   }
//   ::v-deep .ant-table-body::-webkit-scrollbar-corner {
//     background:#e8e8e8;
//   }
</style>
<style lang="scss">
.disabledMenu {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.disabledMenu:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}
.ant-tooltip-inner {
  font-size: 12px;
}
.vue-simple-context-menu {
  box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.3);
  background: #fff;
  &--active {
    background: #fff;
    color: #444;
  }
  &__item {
    width: 180px;
    font-size: 13px;
    span {
      width: 180px;
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
      b {
        font-weight: normal;
      }
    }
    i {
      width: 13px;
      height: 7px;
      border: 2px solid #1890ff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg) scale(0.9) translateY(4px);
    }
    &:hover {
      background-color: lighten(#1890ff, 44%);
      color: #1890ff;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e8e8e8;
  }
}
.tableleft,
.tableright,
.resize {
  float: left;
}
.nhf-editor {
  overflow: hidden;
  &-container {
    max-width: 1400px;
    margin: 0 auto;
  }
}
.nhf-app {
  overflow: hidden;
  height: 100vh;
  max-height: 100vh;
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
  }
}
.nhf-layout h2 {
  font-size: 14px;
  padding: 15px !important;
}
.nhf-header {
  padding: 10px 20px 0;
}
.nhf-title {
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.nhf-logo {
  // width: 80px;
  height: 23px;
  margin-right: 8px;
}
.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
}
.nhf-header-main {
  padding: 8px 15px 4px;
  border-bottom: 1px solid #e8e8e8;
}
.nhf-header-main h3 {
  font-size: 18px;
  color: #444;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  position: relative !important;
}
.ant-table-row-cell-break-word {
  position: relative !important;
}
.nhf-container {
  border-radius: 5px;
  background: #fff;
  min-width: 800px;
  margin: 10px 20px 15px;
  height: calc(100vh - 70px);
  border-radius: 5px;
  background: #fff;
}
.editor-container {
  flex: 1;
}
.col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  h2 {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    font-weight: 900;
    color: #444;
    span {
      &.red {
        color: red;
      }
      &.green {
        color: green;
      }
      b {
        color: #444;
        margin: 0 4px;
      }
    }
  }
}
.ant-layout-content {
  min-height: 100vh;
}
.appBox {
  height: inherit impor !important;
}

.resize {
  cursor: col-resize;
  width: 4px;
  height: calc(100vh - 145px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    color: #444444;
  }
  &:after {
    left: -2px;
    right: -2px;
    border: 1px solid #888;
    border-top: none;
    border-bottom: none;
    height: 22px;
    content: "";
    margin-top: -11px;
    position: absolute;
    top: 50%;
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    background-color: #e8e8e8;
    width: 1px;
  }
}
</style>
